module.exports = __webpack_public_path__ + "static/media/viewSkus.cfb708b5.svg";